export class DisplayResolutionDetector {
    public static isMobile(): boolean {
        return window.innerWidth < 768;
    }
}
